// removed by extract-text-webpack-plugin
module.exports = {"inputContainer":"d_3wkamxCgD1zXiGA0USR","removeInput":"_31wLgj6bMQNbIG9K1JGJA-","cross":"_1jAGCsyWG4HJJ5r7ohSQ4p"};


//////////////////
// WEBPACK FOOTER
// ./components/input.scss
// module id = 1611
// module chunks = 0